// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__29Uu-","content":"styles_content__3G9IJ","flexButton":"styles_flexButton__3Tnao"};